import bigsmart from './bigsmart';
import cobra from './cobra';
import estafeta from './estafeta';
import fedex from './fedex';
import lalamove from './lalamove';
import skydrop from './skydrop';

const shippingProviders = [lalamove, estafeta, skydrop, bigsmart, cobra, fedex];

export default shippingProviders;
